import React from 'react';
import { Button, ButtonProps } from '@mui/material';

export const AuthButton: React.FC<ButtonProps & any> = ({
    children,
    sx,
    ...props
}) => {
    return (
        <Button
            variant="outlined"
            color="secondary"
            fullWidth
            sx={{
                borderColor: 'primary.main',
                color: 'primary.main',
                '&:hover': {
                    borderColor: 'primary.dark',
                    backgroundColor: 'primary.light',
                    color: 'white',
                },
                ...sx,
            }}
            {...props}
        >
            {children}
        </Button>
    );
};
